import dynamic from 'next/dynamic';
import { decodeProfileValues } from '@pkgs/api';

import { useListing } from '@/hooks/queries/useListing';
import { getPreferredProfileContent } from '@/components/property-expose/RichText/RichText';

const PropertyDescription = dynamic(() =>
  import('@/components/property-expose/PropertyDescription/PropertyDescription').then((mod) => mod.PropertyDescription),
);

export const DynamicPropertyDescription = () => {
  const {
    data: { listing, userAccountExclusiveListing, genericListing },
  } = useListing();

  if (!listing && !userAccountExclusiveListing) return null;
  const profile = decodeProfileValues(genericListing?.profile);

  const descriptionContent = getPreferredProfileContent({
    richText: profile.descriptionRich,
    text: profile.description,
  });

  if (!descriptionContent) return null;

  return <PropertyDescription listing={listing ?? userAccountExclusiveListing} />;
};
